import { Action } from 'redux';

import { Download } from '../../../bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '../../../bootstrap/redux/actions/isActionFactory';
import { IContentInfo } from '../../models/IContentInfo';

export interface DownloadAction extends Action {
  item: IContentInfo;
}

export function download(item: IContentInfo): DownloadAction {
  return {
    type: Download,
    item
  };
}

export const isDownloadAction = isActionFactory<DownloadAction>(Download);
